module.exports = __webpack_public_path__ + "img/Natur2.53b048f7.jpg";